import React, { useEffect, useRef, useState } from "react";
import "./Gallery.css";
import { Alert, Button, Container, Spinner } from "react-bootstrap";
import { Toast } from "primereact/toast";
import GalleryDetaile from "./GalleryDetaile";
import { useDispatch, useSelector } from "react-redux";
import { fetchGallery } from "../Redux/GalleryRedux";
import { SendToCart } from "../Redux/AddToCartRedux";

// import { Toast } from 'primereact/toast';
//   const toast = useRef(null);
//   const showSuccess = () => {
//     toast.current.show({severity:'warning', summary: 'Success', detail:'Message Content', life: 3000});
// }
// showSuccess()
// <Toast ref={toast}  position="center"/>
// add notification every where

function Gallery() {
  const dispatch = useDispatch();
  const posts = useSelector((state) => state.gallery);
  const posts2 = useSelector((state) => state.AddToCart);
  const [viewBox, setViewBox] = useState({ Hide: false, UID: "" });
  const [, setShow] = useState(true);
  const [LoadingCart, setLoadingCart] = useState("");
  
  const toast = useRef(null);
  const showSuccess = (Message) => {
    toast.current.show({
      severity: "success",
      summary: "Added to Cart",
      detail: Message,
      life: 1000,
    });
  };
  const [PageData, setPageData] = useState({
    PageNo: 1,
    Search: "",
    SortBy: "1",
  });



  
  const AddToCart = (Name,Value, event) => {
    dispatch(SendToCart(Value));
    setLoadingCart(Value);
    showSuccess(Name+" is being Added to Cart");
    
    event.stopPropagation();
  };

  const IsLogin = useSelector((state) => state.GlobalStatus.data);

  useEffect(() => {
    dispatch(fetchGallery(PageData));
  }, [dispatch, PageData]);

  const openDetailedDilogBox = (UID) => {
    setViewBox({ Hide: true, UID: UID });
  };

  const PageMotion = (Action) => {
    if (Action === "INC") {
      setPageData({ ...PageData, PageNo: PageData["PageNo"] + 1 });
    } else {
      if (PageData["PageNo"] > 1) {
        setPageData({ ...PageData, PageNo: PageData["PageNo"] - 1 });
      }
    }
  };
 
  return (
    <>
      <Toast ref={toast} position="bottom-center" />
      {IsLogin["IsLogedIn"] ? null : (
        <Alert
          variant="warning"
          className="Alert01"
          onClose={() => setShow(false)}
          dismissible
        >
          Login To Purchase
        </Alert>
      )}

      <div className="FilterBar01">
        <div className="FilterBar02">
          <Button
            className="pi pi-angle-left Button01"
            onClick={() => PageMotion("DEC")}
          ></Button>
          <input className="PageIP01" value={PageData["PageNo"]} disabled />
          <Button
            className="pi pi-angle-right Button01"
            onClick={() => PageMotion("INC")}
          ></Button>
        </div>
        <div className="FilterBar03">
          <button
            className="btn btn-secondary dropdown-toggle Button02"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Sort
          </button>
          <ul className="dropdown-menu">
            <li
              className="dropdown-item Button021"
              onClick={() => setPageData({ ...PageData, SortBy: "1" })}
            >
              New to Old
            </li>
            <li
              className="dropdown-item Button021"
              onClick={() => setPageData({ ...PageData, SortBy: "2" })}
            >
              Old to New
            </li>
            <div className="dropdown-divider"></div>
            <li
              className="dropdown-item Button021"
              onClick={() => setPageData({ ...PageData, SortBy: "3" })}
            >
              Price High to Low
            </li>
            <li
              className="dropdown-item Button021"
              onClick={() => setPageData({ ...PageData, SortBy: "4" })}
            >
              Price Low to High
            </li>
          </ul>
        </div>
        <div className="FilterBar04">
          <input
            className="SearchIP01"
            placeholder="Search"
            id="Search01"
            defaultValue={PageData["Search"]}
          ></input>
          <Button
            className="pi pi-search Button03"
            onClick={() =>
              setPageData({
                ...PageData,
                Search: document.getElementById("Search01").value,
              })
            }
          ></Button>
        </div>
      </div>
      <Container fluid="fluid" className="Cointainer01">
        <div className="row Div01">
          {posts.data?.map((post) => (
            <div
              key={post.UID}
              className="ArtBox01 col-md"
              onClick={() => openDetailedDilogBox(post.UID)}
            >
              <div className="PhotosFrame01">
                <img
                  className="Photos01"
                  src={
                    // process.env.REACT_APP_BackEndIP+"/Static/Art/" + post.UID + "/1.png"
                    `${process.env.REACT_APP_BackEndIP}/Static/Art/${post.UID}/1.png?${new Date().getTime()}`
                  }
                  alt="Not Available"
                />

                {IsLogin["IsLogedIn"] ? (
                  <>
                    {parseInt(post.Qty) > parseInt(post.CQty) ? (
                      posts2["isLoading"] && LoadingCart === post.UID ? (
                        <i className="pi pi-spin pi-spinner CartButton01"></i>
                      ) : (
                        <>
                          {post.CQty === "0" ? (
                            <i
                              className="pi pi-shopping-cart CartGreen CartButton01"
                              onClick={(event) => AddToCart(post.Name,post.UID, event)}
                            ></i>
                          ) : (
                            <i
                              className="pi pi-shopping-cart CartYellow CartButton01"
                              onClick={(event) => AddToCart(post.Name,post.UID, event)}
                            ></i>
                          )}
                        </>
                      )
                    ) : (
                      <i
                        className="pi pi-shopping-cart  CartButton01 CartRed"
                        onClick={(event) => event.stopPropagation()}
                      ></i>
                    )}
                  </>
                ) : null}
              </div>
              <div className="TextFrame01">
                <p>
                  <strong>{post.Name}</strong>
                  <br></br>
                  {post.Dimensions}
                  <br></br>
                  {"Rs " + post.Price}
                </p>
              </div>
            </div>
          ))}
        </div>

        <GalleryDetaile
          show={viewBox.Hide}
          onHide={() => setViewBox({ ...viewBox, Hide: false })}
          uid={viewBox.UID}
        />
      </Container>
      <div
        className={posts.isLoading + " d-flex justify-content-center Loading01"}
      >
        <Spinner animation="border" variant="secondary" />
      </div>

      <div className={posts.isEmpty + " d-flex justify-content-center"}>
        <h1>No Data Found</h1>
      </div>
      <div className={posts.isError + " d-flex justify-content-center"}>
        <h1>Server Is Under Maintenance</h1>
      </div>
    </>
  );
}

export default Gallery;
